import { DateTime } from "luxon"

const API_CALENDAR_DATE_FORMAT = "yyyy-MM-dd"

export function parseApiCalendarDate(value: string | null | undefined): DateTime | undefined {
	if (value === null || value === undefined) {
		return undefined
	}
	const trimmed = String(value).trim()
	if (!trimmed) {
		return undefined
	}
	const dt = DateTime.fromFormat(trimmed, API_CALENDAR_DATE_FORMAT, { zone: "local" })
	return (dt.isValid) ? dt : undefined
}
